import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import WebhookEndpoint from "../../models/webhook-endpoint";
import WebhookEndpointForm from "./WebhookEndpointForm";

interface WebhookEndpointCreateModalProps {
  show: boolean;
  onCancel: () => void | Promise<void>;
  onSuccess: (_?: WebhookEndpoint) => void | Promise<void>;
}

const WebhookEndpointCreateModal: React.FC<WebhookEndpointCreateModalProps> = ({
  show,
  onCancel,
  onSuccess,
}) => {
  return (
    <CModal show={show} onClose={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Nuevo Webhook</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          {show ? (
            <WebhookEndpointForm onCancel={onCancel} onSuccess={onSuccess} />
          ) : (
            <></>
          )}
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default WebhookEndpointCreateModal;
